import { combineReducers } from 'redux-immutable';
import benefits from './benefits';
import filter from './filter';
import loader from './loader';
import data from './member-info';

export default combineReducers({
  benefits, // array of benefit IDs for grid
  filter, // array of category and benefit IDs for filterbar
  loader, // overall component loader
  data, // card member info data
});
